<template>
  <div class="dashboardTblComponent" :class="{dividerBottom: !$targetMake.isSeller}">
    <dl>
      <dt>友達追加状況</dt>
      <dd>
        <table-top-buttons :headerButtons="headerButtons" :is-bottom="false" :button-event="buttonEvent"></table-top-buttons>
        <div class="bottomSpace">
          <table class="UXTbl tblHover">
            <colgroup>
              <col v-for="(header, index) in lineFriendHeader" :key="index" :style="{ width: header.width }">
            </colgroup>
            <thead>
            <tr>
              <th v-for="(header, index) in lineFriendHeader" :key="index">{{ header.text }}</th>
            </tr>
            </thead>
            <tbody class="linefriendBody">
              <tr v-for="(data, index) in friendDatas" :key="index">
                <td class="bold">{{ dateAddWeekday(data.targetDate) }}</td>
                <td>{{ data.prevDayDiff }}</td>
                <td>{{ data.followCount }}</td>
                <td>{{ data.unFollowCount }}</td>
                <td>{{ data.useFollowCount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </dd>
    </dl>
    <line-friend-status-dialog
      :dialog="dialog"
      :lineFriendHeader="lineFriendHeader"
      @dialogControl="dialogControl"
      :brandId="brandId"
      :lineChannel="lineChannel"
      ref="lineFriendStatusDialog"
    >
    </line-friend-status-dialog>
  </div>
</template>

<script>
import helper from '@/util/helpers'
import tableTopButtons from '@/components/tableTopButtons'
import lineFriendStatusDialog from './lineFriendStatusDialog'

export default {
  components: {
    tableTopButtons,
    lineFriendStatusDialog
  },
  props: {
    brandId: {
      type: Number
    },
    lineChannel: {
      type: Number
    }
  },
  data: () => ({
    lineFriendHeader: [
      {text: '日付', width: '100px'},
      {text: '前日比', width: '70px'},
      {text: '登録数', width: '70px'},
      {text: 'ブロックされた数', width: '120px'},
      {text: '有効友だち数', width: '120px'}
    ],
    helper,
    dialog: false,
    friendDatas: [],
    temp: {
      targetDate: '',
      prevDayDiff: 0,
      followCount: 0,
      unFollowCount: 0,
      useFollowCount: 0
    }
  }),
  computed: {
    headerButtons () {
      return [
        { text: 'もっと見る', isRight: true, isInfo: true }
      ]
    }
  },
  watch: {
    lineChannel () {
      this.getFollowTable()
    }
  },
  mounted () {
    this.getFollowTable()
  },
  methods: {
    buttonEvent (button) {
      if (button.isInfo) {
        this.dialogControl()
      }
    },
    dialogControl () {
      this.dialog = !this.dialog
    },
    getFollowTable () {
      this.$http({
        method: 'GET',
        url: 'api/brandLineStatus/getFollowCount',
        params: {
          brandId: this.brandId,
          moduleChannelId: this.lineChannel,
          endDate: this.$moment(new Date()).format('YYYYMMDD'),
          startDate: this.$moment(new Date()).subtract(6, 'days').format('YYYYMMDD')
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.friendDatas = res.data.data
        }
      })
    },
    dateAddWeekday (date) {
      return helper.printTimeStampMMMDoddFromDateTime(date)
    }
  }
}
</script>

<style lang="scss" scoped>
.linefriendBody{
  td {
    font-size: 12px !important;
  }
  .bold{
    font-weight: 700 !important;
  }
}
.dashboardTblComponent {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/fragments/lineFriendReport.vue